// extracted by mini-css-extract-plugin
module.exports = {"root":"NotFound-module__root--2Gp-6"};